
import React from 'react';
import { Icon } from 'semantic-ui-react';
import './index.scss';

const DragHandle = ({
    ref,
    disabled,
    isDragging,
    size = 'large',
    ...otherProps
}) => (
    <Icon
        {...otherProps}
        ref={ref} 
        disabled={disabled} 
        size={size}
        className={`fa-solid fa-up-down-left-right DragAndDropHandle${isDragging ? ` DragAndDropHandle--dragging` : ''}`} 
    />
)

export default DragHandle;
